import React, { useState, useEffect } from 'react';

import './styles.css';

import checkDeviceType from '../../checkDeviceType';

import IconLogo from '../../assets/icon-logo.png';
import IconHorizontal from '../../assets/icon-horizontal.png';
import { Link } from 'react-router-dom';
import UserMenuLink from './UserMenuLink';
import PageLink from './PageLink';
import {
    FaBars,
    FaUser,
    FaUserTie,
    FaUsers,
    FaBell,
    // FaShoppingCart,
    FaFutbol,
    FaRegCalendarAlt,
    FaArrowCircleLeft,
    FaExchangeAlt,
    FaFileInvoiceDollar,
    FaCog,
    FaCubes,
    FaPiggyBank,
} from "react-icons/fa";

import userServices from '../../services/userServices';

import loadTextTest from '../../functions/loadTextTest';

import UserPhoto from '../UserPhoto';
import { getAdmFinAccess, accessTypes } from '../../services/accessServices';

function getInfo(info) {
    return info ? info : {}
}

function MainMenu(props) {
    const [deviceType, setDeviceType] = useState(checkDeviceType());
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const userType = localStorage.getItem("_userType");
    const academyInfos =  getInfo(JSON.parse(localStorage.getItem("_academyInfos")))
    const coachInfos =  getInfo(JSON.parse(localStorage.getItem("_coachInfos")))
    const studentInfos =  getInfo(JSON.parse(localStorage.getItem("_studentInfos")))
    const accessInfos =  getInfo(JSON.parse(localStorage.getItem("_accessInfos")))
    const accesses = getAdmFinAccess();

    useEffect(() => {
        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType())
        });
    }, [])

    function logout() {
        userServices.logout();
    }

    function selectBaseRoute() {
        switch (userType) {
            case "professor":
                return "/professor";
            case "aluno":
                return "/aluno";
            case "acesso":
                return "/";
            default:
                return "/academia";
        }
    }

    function selectUserPhoto() {
        if (props.studentMenu) return studentInfos.foto;
        else if (props.studentMenu) return studentInfos.foto;
        else if (academyInfos) return academyInfos.logo;
        else if (accessInfos) return accessInfos.foto;
        else return null;
    }

    return (
        <>
            {
                deviceType !== 'desktop' ?
                    <div className='menu-mobile'>
                        <button onClick={() => setShowMobileMenu(true)}><FaBars /></button>
                        <img src={IconLogo} alt="Ícone logotipo" />
                        <Link to={selectBaseRoute()}>
                            <UserPhoto src={selectUserPhoto()} />
                        </Link>
                    </div>
                    : []
            }
            <nav className={'main-menu' + (showMobileMenu ? ' show-mobile-menu' : '')}>
                <img src={IconHorizontal} alt="Ícone horizontal" className='main-menu-logo' />
                {/* admin-fin */}
                {
                    props.admFinMenu ?
                        <>
                            <UserMenuLink
                                to='/admfin'
                                name={loadTextTest(accessInfos && accessInfos.nome ? `${accessInfos.nome}` : null)}
                                info="Adm/Fin"
                                img={accessInfos ? accessInfos.foto : null}
                                selected={props.selected === 'home'}
                            />
                            {
                                accesses.some(access => access.tipo === accessTypes[1][1] || access.tipo === accessTypes[0][1]) ? 
                                <PageLink to='/admfin/contas' icon={<FaFileInvoiceDollar />} text='Contas' selected={props.selected === 'bills'} />
                                :
                                null
                            }
                            {
                                accesses.some(access => access.tipo === accessTypes[1][1] || access.tipo === accessTypes[0][1]) ? 
                                <PageLink to='/admfin/contas_colaborador' icon={<FaFileInvoiceDollar />} text='Contas Colaborador' selected={props.selected === 'collaborator bills'} />
                                :
                                null
                            }
                            {
                                accesses.some(access => access.tipo === accessTypes[2][1] || access.tipo === accessTypes[0][1]) ? 
                                <PageLink to='/admfin/contas_bancarias' icon={<FaPiggyBank />} text='Contas Bancárias' selected={props.selected === 'bank_accounts'} />
                                :
                                null
                            }
                            {
                                accesses.some(access => access.tipo === accessTypes[3][1] || access.tipo === accessTypes[0][1]) ? 
                                <PageLink to='/admfin/cadastros' icon={<FaCog />} text='Cadastros' selected={props.selected === 'records'} />
                                :
                                null
                            }
                            {
                                accesses.some(access => access.tipo === accessTypes[4][1] || access.tipo === accessTypes[0][1]) ? 
                                <PageLink to='/admfin/estoque' icon={<FaCubes />} text='Estoque' selected={props.selected === 'stocks'} />
                                :
                                null
                            }
                            {/* <PageLink to='/admfin/relatorios' icon={<FaChartBar />} text='Relatórios' selected={props.selected === 'reports'} /> */}
                            <PageLink to='/' icon={<FaExchangeAlt />} text='Trocar módulo' />
                            <PageLink onClick={logout} to='/' icon={<FaArrowCircleLeft />} text='Sair' />
                        </>
                        : []
                }
                {/* admin */}
                {
                    props.adminMenu ?
                        <>
                            <UserMenuLink
                                to='/admin'
                                name={loadTextTest(accessInfos && accessInfos.nome ? `${accessInfos.nome}` : null)}
                                info="Administrador"
                                img={accessInfos ? accessInfos.foto : null}
                                selected={props.selected === 'home'}
                            />
                            <PageLink to='/admin/academias' icon={<FaFutbol />} text='Academias' selected={props.selected === 'academies'} />
                            <PageLink to='/admin/acessos' icon={<FaUser />} text='Acessos' selected={props.selected === 'accesses'} />
                            <PageLink to='/' icon={<FaExchangeAlt />} text='Trocar módulo' />
                            <PageLink onClick={logout} to='/' icon={<FaArrowCircleLeft />} text='Sair' />
                        </>
                        : []
                }
                {
                    props.studentMenu ?
                        <>
                            <UserMenuLink
                                to='/aluno'
                                name={loadTextTest(studentInfos && studentInfos.nome && studentInfos.sobrenome ? `${studentInfos.nome} ${studentInfos.sobrenome}` : null)}
                                info={loadTextTest(studentInfos && studentInfos.turma ? `Turma ${studentInfos.turma.nome}` : null)}
                                img={studentInfos.foto}
                                selected={props.selected === 'home'}
                            />
                            <PageLink to='/aluno/perfil' icon={<FaUser />} text='Meu perfil' selected={props.selected === 'profile'} />
                            <PageLink to='/aluno/notificacoes' icon={<FaBell />} text='Notificações' selected={props.selected === 'notifications'} />
                            <PageLink to='/' icon={<FaExchangeAlt />} text='Trocar módulo' />
                            <PageLink onClick={logout} to='/' icon={<FaArrowCircleLeft />} text='Sair' />
                        </>
                        : []
                }
                {
                    props.coachMenu ?
                        <>
                            <UserMenuLink
                                to='/professor'
                                name={loadTextTest(coachInfos && coachInfos.nome && coachInfos.sobrenome ? `${coachInfos.nome} ${coachInfos.sobrenome}` : null)}
                                info={loadTextTest(academyInfos.cidade)}
                                img={coachInfos ? coachInfos.foto : null}
                                selected={props.selected === 'home'}
                            />
                            <PageLink to='/professor/perfil' icon={<FaUser />} text='Meu perfil' selected={props.selected === 'profile'} />
                            <PageLink to='/professor/alunos' icon={<FaUser />} text='Alunos' selected={props.selected === 'students'} />
                            <PageLink to='/professor/turmas' icon={<FaUsers />} text='Turmas' selected={props.selected === 'classes'} />
                            {/* <PageLink external to='https://sigeloja.com.br/' icon={<FaShoppingCart />} text='Loja BCFC' selected={props.selected === 'store'} /> */}
                            <PageLink to='/professor/treinos' icon={<FaFutbol />} text='Treinos' selected={props.selected === 'trainings'} />
                            <PageLink to='/professor/calendario' icon={<FaRegCalendarAlt />} text='Calendário' selected={props.selected === 'calendar'} />
                            <PageLink to='/' icon={<FaExchangeAlt />} text='Trocar módulo' />
                            <PageLink onClick={logout} to='/' icon={<FaArrowCircleLeft />} text='Sair' />
                        </>
                        : []
                }
                {
                    props.adminMenu || props.admFinMenu || props.studentMenu || props.coachMenu ?
                        [] :
                        <>
                            <UserMenuLink
                                to='/academia'
                                name={loadTextTest(academyInfos.nome)}
                                info={loadTextTest(academyInfos.cidade)}
                                img={academyInfos.logo}
                                selected={props.selected === 'home'}
                            />
                            <PageLink to='/academia/alunos' icon={<FaUser />} text='Alunos' selected={props.selected === 'students'} />
                            <PageLink to='/academia/professores' icon={<FaUserTie />} text='Professores' selected={props.selected === 'coaches'} />
                            <PageLink to='/academia/turmas' icon={<FaUsers />} text='Turmas' selected={props.selected === 'classes'} />
                            {/* <PageLink external to='https://sigeloja.com.br/' icon={<FaShoppingCart />} text='Loja BCFC' selected={props.selected === 'store'} /> */}
                            <PageLink to='/academia/treinos' icon={<FaFutbol />} text='Treinos' selected={props.selected === 'trainings'} />
                            <PageLink to='/academia/calendario' icon={<FaRegCalendarAlt />} text='Calendário' selected={props.selected === 'calendar'} />
                            <PageLink to='/academia/contas' icon={<FaFileInvoiceDollar />} text='Contas' selected={props.selected === 'bills'} />
                            <PageLink to='/' icon={<FaExchangeAlt />} text='Trocar módulo' />
                            <PageLink onClick={logout} to='/' icon={<FaArrowCircleLeft />} text='Sair' />
                        </>
                }
                {
                    deviceType !== 'desktop' ?
                        <button onClick={() => setShowMobileMenu(false)} className='hide-menu'>Fechar</button>
                        : []
                }
            </nav>
        </>
    )
}

export default MainMenu;